export default [
    {
        // path: '/np/app/:npAppId/:npTid',
        path: '/np/app',
        component: () => import('views/modules/np/app/index.vue'),
        meta: {
            test: 123
        }
        // meta: {
        //     parent: '/product/list',
        //     icon: 'el-icon-document',
        //     title: '添加内容',
        //     path: '',
        //     isApp: false,
        //     isIframe: false,
        //     isLink: false,
        //     isAffix: false,
        //     isHide: false,
        //     params: {},
        // },
    },
    {
        path: '/np/category',
        component: () => import('@/numberPortal/views/lowcode/index.vue'),
    },
    {
        path: '/np/form/app',
        component: () => import('views/modules/np/form/app'),
        meta: {
            title: '表单管理',
        },
    },
    {
        path: '/np/design',
        name: 'product-select-add',
        component: () => import('views/modules/np/design'),
    },
];
